import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShortcut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"shortcut, hotkey, powerkey, skill"} maskId="square-filled-radius-0-stroke-1-IconShortcut"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM8.5 13H11.667L11 17.5L15.5 11H12.333L13 6.5L8.5 13Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconShortcut;
